package devxertech.com.component


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.style.SpinOnce
import devxertech.com.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s


@Composable
fun ProgressIndicator(
    size: CSSLengthNumericValue = 20.px,
    color: com.varabyte.kobweb.compose.ui.graphics.Color.Rgb? = null
) {
    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .height(size)
            .width(size)
            .animation(
                SpinOnce.toAnimation( // ✅ fixed here
                    iterationCount = AnimationIterationCount.Infinite,
                    duration = 1.s
                )
            )
            .styleModifier {
                property("border", "3px solid #f3f3f3")
                property("border-top", "3px solid ${color ?: sitePalette.topBarMenuText.rgb}")
                property("border-radius", "50%")
            }
    )
}

//@Composable
//fun ProgressIndicator(
//    size: CSSLengthNumericValue = 20.px,
//    color: com.varabyte.kobweb.compose.ui.graphics.Color.Rgb? = null
//) {
//    val sitePalette = ColorMode.current.toSitePalette()
//
//    Box(contentAlignment = Alignment.Center, modifier = Modifier.height(size).width(size).animation(
//        SpinOnce.toAnimation(
//            iterationCount = AnimationIterationCount.Infinite,
//            duration = 1.s
//        )
//    )
//        .styleModifier {
//            property(
//                "border",
//                "3px solid #f3f3f3"
//            )
//            property("border-top", "3px solid ${color ?: sitePalette.topBarMenuText.rgb}")
//            property("border-radius", "50%")
//            property("animation", "spin 1s linear infinite")
//
//        }) { }
//
//}
